import React from 'react';
import SocialsPage from './components/SocialsPage';
import './index.css';

function App() {
  return (
    <div className="App">
      <SocialsPage />
    </div>
  );
}

export default App;